export const locale = {
    lang: 'ar',
    data: {
        LIST_WHERE_TO_PLACE: 'أين تريد وضع هذه البطاقات؟',
        LIST_ACTIVITY: 'القائمة',
        CANCEL: 'إلغاء',
        SAVE: 'حِفْظْ',
    }
};
